/*
* This class is update library almost all
*
* */
import {Loading} from "aws-amplify-react";
import {ClipLoader} from "react-spinners";
import React from "react";


export default class MyLoading extends Loading {
    constructor(props) {
        super(props);
        this.state = {
            display: false
        };
        this._validAuthStates = ['loading', 'signedIn'];
    }

    componentDidMount() {
        // すでにsignedInの場合の、ローディング画面を表示させる処理
        const path = window.location.pathname;
        if (path !== '/') {
            // oauth処理時はローディングを操作
            this.setState({display: true})
            setTimeout(() => {
                this.setState({display: false})
            }, 5000);

        } else {
            // 通常時はローディングを表示させない
            setTimeout(() => {
                this.setState({display: false})
            }, 0);

        }

    }

    componentDidUpdate(prevProps) {
        // ログイン処理中の、ローディング画面を表示させる処理
        if (prevProps.authState !== this.props.authState) {
            if (prevProps.authState  === "CompChangeUserInfo") {
                this.setState({display: true})
            }
            setTimeout(() => {
                this.setState({display: false})
            }, 30000);
        }
    }

    showComponent(theme) {
        if (this.state.display){
            return (
                <div className="loading">
                    <ClipLoader
                        sizeUnit={"px"}
                        size={150}
                        color={'#123abc'}
                        loading={true}
                    />
                </div>
            )
        } else {
            return null;
        }
    }

}